import { Component, Input } from '@angular/core';
import { maxBornOnDate, minBornOnDate } from '@app/constants/dates';
import { FeatureFlag } from '@app/enums';
import { isBornOnOutsideCppQppRange, makePhoneNumberMask } from '@app/functions';
import { TextMask } from '@app/interfaces';
import { Employee } from '@app/models/employee/employee.model';
import { FeatureService } from '@app/services/feature.service';
import { BaseForm } from '@forms/base.form';
import { Account } from '@models/account/account.model';

@Component({
    selector: 'app-form-personal-information',
    templateUrl: './personal-information.form.html',
    styleUrls: ['./personal-information.style.scss'],
})
export class PersonalInformationForm extends BaseForm {
    @Input() account: Account;
    @Input() employee: Employee;
    editSinPermission = Employee.sinPermission.some('update');
    editBornOnPermission = Employee.bornOnPermission.some('update');
    phoneNumberMask: TextMask = makePhoneNumberMask();
    minBornOnDate = minBornOnDate;
    maxBornOnDate = maxBornOnDate;

    updateLegalNamePermission: string[] = Account.legalNamePermission.some('update');
    updateLegalSexPermission: string[] = Employee.legalSexPermission.some('update');
    shouldShowBirthdayVisibility = false;

    // Tracks the date as it's being typed/picked, ahead of it being committed to employee.bornOn
    private bornOnPreview: Date | null | undefined;

    constructor(private featureService: FeatureService) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.shouldShowBirthdayVisibility = await this.featureService.has(FeatureFlag.birthdayVisibility);
    }

    beforeShow(): void {
        super.beforeShow();
        this.bornOnPreview = undefined;
    }

    onBornOnInput(bornOn: Date | null): void {
        this.bornOnPreview = bornOn;
    }

    get showBornOnComplianceWarning(): boolean {
        const bornOn = this.bornOnPreview !== undefined ? this.bornOnPreview : this.employee?.bornOn;
        return isBornOnOutsideCppQppRange(bornOn, this.employee?.office?.province);
    }

    submit(): void {
        super.submit();
    }
}
